import { configureStore } from '@reduxjs/toolkit';
import appDataReducer from './utils/appdata';

export const store = configureStore({
  reducer: {
    appData: appDataReducer,
    // ...other reducers...
  },
});